import React from 'react'
import '../css/Footer.css';
const Footer = () => {
  return (
      <div id="footer" className="footer">&copy; 2025 Replicaessembler. All rights reserved.</div>
  )
}

export default Footer;